import React from 'react'
import { observer } from 'mobx-react'
import { restaurantCenter, cartMobx, storeMobx, menuMobx } from 'restaurant'
import { payPlanMobx, timePickMobx } from '@mobxStore'
import { loadingLayer, modalLayer, getPlatform } from '@utils'
import { useDebounce } from '@dt/fe-utils'
import { payOrder, payOrderReset } from '@common/utils/pay'
import CashierController from '@ctrls/cashierController'
import { ConfirmModal } from '@cps'

interface IProps {
  saveError?: () => void;
}

const PayButton: React.FC<IProps> = ({ saveError }) => {
  const { isWeixinMiniProgram } = getPlatform()
  const history = CashierController.history()
  const isCanOrder = cartMobx.cartResult.totalCnt && menuMobx.isAvailable && (((storeMobx.info.isMobileBookingOrder || timePickMobx.timePickList.length) && (cartMobx.info.startTime || (cartMobx.info.startTime === '' && storeMobx.info.inSale))) || storeMobx.info.inSale)
  const isCanPay = (isCanOrder || cartMobx.posOrderPay) && payPlanMobx.canPay

  const handlePay = useDebounce((isCanPay) => {
    isCanPay && payOrder({
      history,
      handleSaveError: () => {
        if (saveError) {
          saveError()
        } else {
          modalLayer(ConfirmModal, {
            title: i18n.t('common.attention'),
            confirmText: i18n.t('cart.refreshMenu'),
            children: (<span>{i18n.t('cart.errorProduct')}</span>),
            className: 'cart-confirm-modal'
          }, 'confirmModal').then(() => {
            loadingLayer.show()
            restaurantCenter.initAll()
            setTimeout(() => loadingLayer.hide(), 2000)
          }).catch(() => {})
        }
      },
      handlePayError: (forceOrder) => {
        modalLayer.closeAll()
        modalLayer(ConfirmModal, {
          title: i18n.t('common.attention'),
          confirmText: i18n.t('checkout.confirmRefresh'),
          children: (<span>{i18n.t('checkout.payOrderHasError')}</span>),
          className: 'cart-confirm-modal',
          backdropDismiss: false
        }, 'confirmModal').then(async () => {
          loadingLayer.show()
          await payOrderReset(forceOrder)
          loadingLayer.hide()
        }).catch(() => {})
      }
    })
  }, 500)

  return (
    <>
      <div
        className={`cart-btn ${isCanPay ? '' : 'disabled'}`}
        data-cypid='payBtn'
        onClick={() => handlePay(isCanPay)}
      >
        {i18n.t(isWeixinMiniProgram ? 'menu.go_pay' : 'pay.pay')}
      </div>
    </>
  )
}

export default observer(PayButton)
